import { useMemo } from 'react';
import { checkPermission, } from '@zurich/common/permission';
import { useNextAppSession } from './useNextAppSession';
export function createUsePermissions() {
    return (props) => {
        const { session } = useNextAppSession({
            required: props?.sessionRequired ?? false,
        });
        return useMemo(() => {
            const permissions = session?.permissions || []; // leap of faith to the passed enum type (which can only be an enum value)
            return {
                permissions,
                checkPermission: (permission, type) => checkPermission(permissions, permission, type),
            };
        }, [session]);
    };
}
export const useNextAppPermissions = createUsePermissions();
